<template>
  <div class="custom-radio-button">
    <button
      v-for="(option, index) in options"
      :key="index"
      :class="[
        'radio-button-item',
        { 'radio-button-checked': option.value === selectedValue },
      ]"
      @click="selectedValue = option.value"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: "RadioButton",
  props: {
    value: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedValue: this.value,
    };
  },
  watch: {
    selectedValue() {
      this.$emit("input", this.selectedValue);
    },
    value(newValue) {
      this.selectedValue = newValue;
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-radio-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 24px;

  .radio-button-item {
    flex: 1;
    height: 42px;
    border: 1.5px solid rgba(24, 23, 23, 0.2);
    border-radius: 20px;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.03em;
    color: rgba(24, 23, 23, 0.8);
    background: #ffffff;
    cursor: pointer;
  }
  .radio-button-checked {
    border: 1.5px solid #48a3ff;
    color: #48a3ff;
  }
}
</style>
